<div class="nh-bell">
  <button
    mat-icon-button
    type="button"
    class="nh-bell__trigger"
    ewentsTooltip="Notifications"
    ewentsTooltipPosition="below"
    aria-label="Notifications"
    [attr.aria-label]="
      unreadCount() > 0 ? 'Notifications, ' + badgeLabel() + ' unread' : 'Notifications'
    "
    [attr.aria-expanded]="open()"
    (click)="toggle()"
  >
    <mat-icon>notifications</mat-icon>
    @if (unreadCount() > 0) {
      <span class="nh-bell__badge" aria-hidden="true"></span>
    }
  </button>

  @if (open()) {
    <div class="nh-bell__panel" role="dialog" aria-label="Notifications">
      <header class="nh-bell__header">
        <div>
          <h2>Notifications</h2>
          @if (unreadCount() > 0) {
            <p>{{ unreadCount() }} unread</p>
          } @else {
            <p>You're all caught up</p>
          }
        </div>
        @if (unreadCount() > 0) {
          <button type="button" class="nh-bell__mark-all" (click)="markAllRead()">
            Mark all read
          </button>
        }
      </header>

      <div class="nh-bell__list">
        @if (loading()) {
          <ewents-loading layout="compact" label="Loading…" />
        } @else if (items().length === 0) {
          <div class="nh-bell__empty-state">
            <mat-icon>notifications_none</mat-icon>
            <p>No notifications yet</p>
            <span>System reminders for you will show up here.</span>
          </div>
        } @else {
          @for (item of items(); track item.id) {
            <div
              class="nh-bell__item"
              [class.nh-bell__item--unread]="!item.readAt"
              role="button"
              tabindex="0"
              (click)="onItemClick(item)"
              (keydown.enter)="onItemClick(item)"
              (keydown.space)="$event.preventDefault(); onItemClick(item)"
            >
              <span class="nh-bell__dot" aria-hidden="true"></span>
              <span class="nh-bell__item-body">
                <span
                  class="nh-bell__title"
                  [ewentsTooltip]="item.title"
                  ewentsTooltipOnlyWhenTruncated
                  ewentsTooltipPosition="below"
                  >{{ item.title }}</span
                >
                <span
                  class="nh-bell__text"
                  [ewentsTooltip]="item.body"
                  ewentsTooltipOnlyWhenTruncated
                  ewentsTooltipPosition="below"
                  >{{ item.body }}</span
                >
                <span class="nh-bell__meta">{{ relativeTime(item.createdAt) }}</span>
              </span>
              <button
                type="button"
                class="nh-bell__delete"
                aria-label="Delete notification"
                ewentsTooltip="Delete"
                (click)="onDelete($event, item)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
